import styled from 'styled-components'
import { Asterisk } from '../Asterisk'
import { ReactNode } from 'react'

export interface LabelProps {
  children: ReactNode
  required?: boolean
}

export const Label = ({ children, required }: LabelProps) => {
  return (
    <LabelWrapper>
      {children}
      {required && <AsteriskStyled />}
    </LabelWrapper>
  )
}

export const LabelWrapper = styled.label`
  display: flex;
  font-weight: 700;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.Corduroy};
`

const AsteriskStyled = styled(Asterisk)`
  margin-left: 8px;
`
